<template>
  <el-footer id="my_footer" height="210px">
    <div class="foot-left">
      <div class="header-logo">WORLD TRIP</div>
      <div class="entry_item">
        <div
          v-for="(entry_item,entry_index) in footer_entry"
          :key="entry_index"
          @click="toRoute(entry_item.route)"
        >{{entry_item.name}}</div>
      </div>
      <div style="margin-top:16px;">{{footer_copyright}}</div>
      <!-- <span>{{footer_record}}</span>
      <span>{{footer_company}}</span>-->
    </div>
    <img src="../../assets/images/wechat_code.jpg" alt />
  </el-footer>
</template>
<script>
export default {
  name: "my_footer",
  data() {
    return {
      footer_entry: [
        { name: "关于我们", route: "/about_us" },
        { name: "商务合作", route: "/business_cooperation" },
        { name: "联系我们", route: "/concat_us" },
        { name: "服务条款", route: "/concat_us" },
        { name: "隐私政策", route: "/concat_us" }
      ],
      footer_copyright: "© 2019 World Trip 版权所有。",
      footer_record: "京ICP备09040564号",
      footer_company: " 北京正点科技有限公司"
    };
  },
  methods: {
    toRoute(name) {
      this.$router.push(name);
    }
  }
};
</script>
<style scoped>
.el-footer {
  border-top: 1px solid #979797;
  color: #848484;
  font-size: 12px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 105px;
}
.el-footer img {
  width: 119px;
  height: 119px;
  object-fit: cover;
  margin-right: 60px;
}
.foot-left {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
}
.header-logo {
  color: #000000;
  font-size: 28px;
  font-weight: bold;
  font-family: Arial, Helvetica, sans-serif;
}
.el-footer span {
  margin-top: 20px;
}
.entry_item {
  display: flex;
  margin-top: 26px;
}
.entry_item div {
  line-height: 1;
  padding: 0 8px;
  text-align: center;
}
.entry_item div:hover {
  color: #ff5d0e;
  cursor: pointer;
}
.entry_item div:not(:last-child) {
  border-right: 1px solid #848484;
}
.entry_item div:first-child{
  padding-left: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/footer.vue